import React from "react";
import { Row, Col } from "react-bootstrap";
import { withTheme } from "styled-components";
import { Label } from "@irati/ui/src/Typography";
import { Hr } from "@irati/ui/src/Layout";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import Flex from "@irati/ui/src/Flex";
import FormattedMessage from "@irati/utils/lang";
var UnavailableDeal = function (_a) {
    var theme = _a.theme;
    return (React.createElement(React.Fragment, null,
        React.createElement(Hr, null),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Flex, { alignItems: "center" },
                    React.createElement(Icon, { icon: IconTypes.circleDisable, size: 25, color: theme.colors.utility.ink }),
                    React.createElement(Label, { large: true, display: "inline-block", marginLeft: true },
                        React.createElement(FormattedMessage, { id: "perks.components.importantInfoBlock.unavailableDeal.text" })))))));
};
export default withTheme(UnavailableDeal);
